import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError, retry, map } from 'rxjs/operators';

const httpOptions = {     
    headers: new HttpHeaders({        
        'Content-Type':  'application/json; charset=utf-8',    
    })    
};

@Injectable()
export class VivaService {
    constructor(private http: HttpClient) { }

    getStudentViva(rootUrl:string, usercode: string, batch_id:number, student_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/viva/answer', {usercode: usercode, batch_id:batch_id, student_id:student_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    } 

    setVivaMarks(rootUrl:string, usercode: string, student_id:number, question_id:number, marks:number, exam_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/viva/marks/edit', {usercode: usercode, student_id:student_id, question_id:question_id, marks:marks, exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    }
    
    getpracticalMarks(rootUrl:string, student_id:number,exam_id:number):Observable<any> {
        return this.http.post<any>(rootUrl+'proctor/student/practical', { student_id:student_id,exam_id:exam_id}, httpOptions)
            .pipe(map(response => {
                return response;
            }));
    } 
}